<template>
  <div>
    <!-- <Banner /> -->
    <nav class="flex items-center justify-between flex-wrap">
      <a
        href="https://www.philasd.org"
        target="_blank"
        class="flex items-center flex-shrink-0 text-white mr-6 mb-2 md:mx-0"
      >
        <img
          class="logo"
          alt="The School District of Philadelphia"
          src="~/assets/images/logo.png"
        />
      </a>
      <div class="block lg:justify-end flex items-center w-full lg:w-auto">
        <div class="w-full lg:flex">
          <HeaderButton
            to="/compare"
            label="Compare Schools"
            name="check-square"
          />
          <!-- <HeaderButton to="/userguide" label="User Guide" name="map" /> -->
          <HeaderLink
            to="https://cdn.philasd.org/offices/performance/School_Profiles/User_Guide/SDP_School_Profile_User_Guide_FINAL.pdf"
            label="User Guide"
            name="map"
          />
          <HeaderButton
            to="/videotutorials"
            label="Video Tutorials"
            name="film"
          />
          <!-- <HeaderButton to="/glossary" label="Glossary" name="file-alt" /> -->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import HeaderButton from '~/components/Header/HeaderButton.vue'
// import Banner from '~/components/Header/Banner.vue'
import HeaderLink from '~/components/Header/HeaderLink.vue'

export default {
  components: {
    HeaderButton,
    // Banner,
    HeaderLink
  },
  methods: {
    clearFilters: function() {
      this.$store.commit('subpage/filters/clearFilters')
    }
  }
}
</script>

<style scoped>
.logo {
  max-width: 310px;
  height: auto;
}
</style>
